module.exports = "<template> <sio-editable-table config.bind=field value.bind=field.value></sio-editable-table> </template> ";